import React from "react";
import { LanguageCode } from "src/utils/localization/languages/types";

const formatConjunctionItems = (
  names: readonly string[],
  language: LanguageCode
) => {
  try {
    return new Intl.ListFormat(language, { style: "long", type: "conjunction" })
      .formatToParts(names)
      .map((p) => {
        if (p.type == "element")
          return <strong key={p.value}>{p.value}</strong>;
        return p.value;
      });
  } catch {
    return names.map((n) => <strong key={n}>{n}</strong>).join(", ");
  }
};

export const formatConjunction = (
  names: readonly string[],
  language: LanguageCode
) => {
  const items = formatConjunctionItems(names, language);

  if (items.length === 0) return null;
  return <>{items}</>;
};
